
<div class ="yes-no-dialog ">
    <div class="action">
      <h5>{{"label.common.popup."+data.action |translate}}</h5>
    </div>
      <div class="dialog_container">
          <mat-dialog-content>
              <div>
                  <label>{{"label.common.popup."+data.message |translate}}</label>
              </div>
          </mat-dialog-content>
          <mat-dialog-actions class="dialog_actions">
              <dxc-button
                  class="btn-yes btn"
                  label="{{ 'label.common.popup.'+ data.rightBtn| translate }}"
                  [mat-dialog-close]="true"
                  (onClick)="saveDialog()"
                  margin="small"
                  mode="primary">
              </dxc-button>
              <dxc-button
                  class="btn-no btn"
                  label="{{'label.common.popup.'+data.leftBtn | translate}}"
                  [mat-dialog-close]="false"
                  (onClick)="closeDialog()"
                  margin="small"
                  mode="secondary">
              </dxc-button>
          </mat-dialog-actions>
      </div>
  </div>
  <div
  class="bg-color"
 
  *ngIf="data.status == 'send'"
>
<div id="dialogHeader" class="text-center mt-3">
  <img src="{{ data.icon }}" alt="" />
</div>
  <label> {{ "label.common.popup." + data.message | translate }}</label>
</div>
  